import { render, staticRenderFns } from "./VideoFilter.vue?vue&type=template&id=026613e5&scoped=true&"
import script from "./VideoFilter.vue?vue&type=script&lang=js&"
export * from "./VideoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026613e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('026613e5')) {
      api.createRecord('026613e5', component.options)
    } else {
      api.reload('026613e5', component.options)
    }
    module.hot.accept("./VideoFilter.vue?vue&type=template&id=026613e5&scoped=true&", function () {
      api.rerender('026613e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/Includes/VideoFilter.vue"
export default component.exports